import { useState } from 'react';
import { Info } from 'lucide-react';
import { Label } from '@/components/ui/label';

export const selectClass =
  'h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-brand-600 focus:border-brand-600 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100';

export function ChipToggle({ label, selected, onToggle }: { label: string; selected: boolean; onToggle: () => void }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={selected}
      className={
        selected
          ? 'inline-flex h-9 items-center rounded-full bg-brand-600 px-3.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-brand-700'
          : 'inline-flex h-9 items-center rounded-full border border-slate-300 bg-white px-3.5 text-sm font-medium text-slate-700 transition-colors hover:border-brand-400 hover:text-brand-600 dark:border-slate-600 dark:bg-slate-700/60 dark:text-slate-300 dark:hover:border-brand-500 dark:hover:text-brand-400'
      }
    >
      {label}
    </button>
  );
}

export function SupportTooltip({ text }: { text: string }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative inline-flex">
      <button
        type="button"
        className="text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        aria-label="More information"
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      {show && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-52 rounded-lg bg-slate-900 px-3 py-2 text-xs text-white shadow-lg z-20 pointer-events-none dark:bg-slate-800">
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-900 dark:border-t-slate-800" />
        </div>
      )}
    </div>
  );
}

export function LockedField({ label, value, tooltip }: { label: string; value: string; tooltip: string }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5">
        <Label className="text-sm font-medium">{label}</Label>
        <SupportTooltip text={tooltip} />
      </div>
      <div className="flex h-10 w-full items-center rounded-md border border-slate-200 bg-slate-50 px-3 text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400 cursor-not-allowed select-none">
        {value}
      </div>
    </div>
  );
}
